import { take } from "../util/takePayload";
export const getNew = () => ({
    street1: '',
    street2: '',
    city: '',
    state: '',
    postalCode: '',
    country: 'US',
});
export const fromGql = (gqlAddress) => (Object.assign({}, take(gqlAddress, 'street1', 'street2', 'city', 'state', 'postalCode', 'country')));
//# sourceMappingURL=Address.js.map